import axiosInstance from '@/services/axiosInstance'

async function subirAnexo (files, idNEO, tipoDocumento = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const formData = new FormData()
    files.forEach(file => {
      formData.append('file', file.raw)
      // if (tipoDocumento) formData.append('codigoTipoDocumento', tipoDocumento)
    })

    const req = {
      url: 'api/adjuntos/subiranexo?idNEO=' + idNEO + '&codigoTipoDocumento=' + tipoDocumento,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      },
      data: formData
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { subirAnexo }
